var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('editor',_vm._b({on:{"blur":_vm.onBlur,"input":_vm.onInput,"keyup":_vm.onKeyup,"focus":_vm.onFocus,"upload":_vm.onUpload}},'editor',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }